import copy from 'copy-to-clipboard'

const mailFormatter = {
    copyMails (mails) {
        const text = mails.map(x => x).flat().filter(x => !!x).join(';')
        copy(text)
    }
}

export default mailFormatter